import React from 'react';
import moment from 'moment';
import 'moment/locale/da';
import styled from 'styled-components/macro';
import { DayPickerInput, DayPickerMomentLib } from './DayPickerLibrary';
import { BsCaretLeftFill, BsCaretRightFill } from './Icons';

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
const NavButtonNoProps = ({ onClick, className, children }) => (
  <button type="button" onClick={onClick} className={className}>
    {children}
  </button>
);
const StyledNavButton = styled(NavButtonNoProps)`
  border: 0;
  font-size: 18px;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  padding: 5px;
  top: 5px;
  &:hover {
    color: ${({ theme }) => theme.colors.colorBlue};
    cursor: pointer;
  }
  ${({ left }) => left && `left: ${left};`}
  ${({ right }) => right && `right: ${right};`}
`;
const NavBarElement = ({
  onPreviousClick,
  onNextClick,
  showPreviousButton,
  showNextButton,
  className,
}) => (
  <div className={className}>
    {showPreviousButton && (

      <StyledNavButton
        onClick={(evt) => {
          onPreviousClick();
          evt.preventDefault();
          evt.stopPropagation();
          return false;
        }}
        left="5px"
      >
        <BsCaretLeftFill />
      </StyledNavButton>
    )}
    {showNextButton && (
      <StyledNavButton
        onClick={(evt) => {
          onNextClick();
          evt.preventDefault();
          evt.stopPropagation();
          return false;
        }}
        right="5px"
      >
        <BsCaretRightFill />
      </StyledNavButton>
    )}
  </div>
);
const StyledNavBarElement = styled(NavBarElement)`
`;
const DayContainer = styled.div`
  padding-top: 5px;
  ${({ disabled }) => {
    if (disabled) {
      return `
        color: grey;
      `;
    }
    return `
    `;
  }}
`;

const CustomInput = styled(({ error, ...props }) => <input {...props} />)`
  border: 1px solid ${({ theme }) => theme.colors.colorGreyLightAlt};
  color: ${({ theme }) => theme.colors.colorGreyDark};
  ${({ error, theme }) => error && `border-color: ${theme.colors.colorRed};`}
  ${({ disabled }) => (disabled ? '' : 'cursor: pointer;')}
  padding: 11px 15px;
  text-align: right;
  outline: none;
  display: block;
  width: calc(100% - 30px);
  font-size: 14px;

  @media (max-width: 991px) {
    font-size: 16px;
    padding: 14px 10px 12px 10px;
    width: calc(100% - 20px);
  }

  @media screen and (max-width: 767px) {
    text-align: left;
    padding: 24px 10px 2px 10px;
  }
  
  ${({ disabled }) => {
    if (disabled) {
      return `
      `;
    }
    return `
    `;
  }}
`;
const Wrapper = styled.div`
  .DayPickerInput {
    display: block;
    position: relative;
  }
}
  .DayPickerInput-OverlayWrapper {
    left: 50%;
    margin-left: -250px;
    position: absolute;
    background: white;
    z-index: 3;
    width: 500px;
    box-shadow: 0 10px 20px rgba(0,0,0,0.5);

    @media screen and (max-width: 991px) {
      left: auto;
      right: 0;
      margin-left: 0px;
    }

    @media screen and (max-width: 575px) {
      width: calc(100% + 60px);
      left: 50%;
      right: auto;
      transform: translateX(-50%);
    }

    .DayPickerInput-Overlay {
    
      .DayPicker {
        font-size: 14px;
        
        .DayPicker-wrapper {
          border: 1px solid ${({ theme }) => theme.colors.colorGreyLightAlt};
          outline: none;
          cursor: default;
          position: relative;
          width: 100%;

          .DayPicker-NavBar {
            position: absolute;
            height: 40px;
            width: 100%;
          }

          .DayPicker-Month {
            display: block;
            margin: 15px 5px 0 5px;
            .DayPicker-Caption {
              display: block;
              padding: 0 0 10px 0;
              text-align: center;
              width: calc(100%);
              margin-bottom: 0px;
              border-bottom: 1px solid ${({ theme }) => theme.colors.colorGreyLightAlt};
            }

            .DayPicker-Weekdays {
              display: block;
              padding: 0;
              width: 100%;
              margin-top: 0px;

              .DayPicker-WeekdaysRow {
                display: block;
                width: 100%;

                .DayPicker-Weekday {
                  display: inline-block;
                  width: calc(100%/7 - 18px);
                  margin: 2px;
                  padding: 5px;
                  font-weight: bold;
                  text-align: center;
                  @media screen and (max-width: 575px) {
                    width: calc(100%/7 - 14px);
                  }

                  &:first-child {
                    content: "";
                    display: inline-block;
                    width: 25px;
                    height: 10px;
                    padding: 0px;
                    margin: 0px;

                    @media screen and (max-width: 575px) {
                      display: none;
                    }
                  }
                }
              }
            }

            .DayPicker-Body {
              display: block;
              width: 100%;

              .DayPicker-Week {
                display: block;
                width: 100%;
                
                &:after {
                  clear: both;
                }

                .DayPicker-WeekNumber {
                  display: inline-block;
                  padding: 20.5px 0;
                  width: 25px;
                  margin: 2px 0 0 0;
                  text-align: center;
                  outline: none;
                  border: 0;
                  @media screen and (max-width: 575px) {
                      display: none;
                    }
                }

                .DayPicker-Day {
                  display: inline-block;
                  width: calc(100%/7 - 10px);
                  height: 50px;
                  outline: none;
                  border-radius: 0;
                  border: 1px solid ${({ theme }) => theme.colors.colorGreyLightAlt};
                  vertical-align: top;
                  color: ${({ theme }) => theme.colors.colorBlue};
                  font-weight: bold;
                  margin: 2px;
                  position: relative;
                  text-align: center;
                  @media screen and (max-width: 575px) {
                    width: calc(100%/7 - 4.5px);
                    height: 35px;
                    margin: 1px;
                  }
                  div p {
                    @media screen and (max-width: 425px) {
                      position: absolute;
                      width: 100%;
                      text-align: center;
                      bottom: 5px;
                      margin-bottom: 0px;
                      left: 0;
                      font-size: 9px !important;
                    }
                  }

                  &.DayPicker-Day--disabled {
                    background: ${({ theme }) => theme.colors.colorGreyLightAlt};
                    cursor: default;

                    .gntTAG {
                      color: ${({ theme }) => theme.colors.colorGreyLight};
                    }
                  }

                  &.DayPicker-Day--today {
                    border: 1px solid ${({ theme }) => theme.colors.colorBlue};

                    &.DayPicker-Day--disabled {
                      &:hover {
                        background: ${({ theme }) => theme.colors.colorGreyLightAlt};
                      }
                    }
                  }
                  &.DayPicker-Day--selected {
                    color: white;
                    background: ${({ theme }) => theme.colors.colorBlue};
                    cursor: pointer;

                    div, span, * {
                      color: ${({ theme }) => theme.colors.colorWhite};
                    }
                  }
                  &.DayPicker-Day--outside {
                    cursor: pointer;
                    &.DayPicker-Day--disabled {
                      cursor: default;
                      &:hover {
                        background: ${({ theme }) => theme.colors.colorGreyLightAlt};
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
export default class DayPicker extends React.Component {
  constructor(props) {
    super(props);
    this.renderDay = this.renderDay.bind(this);
    this.onDayChange = this.onDayChange.bind(this);
    this.state = {

    };
  }

  componentWillMount() {
    this.calculateState(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.calculateState(nextProps);
  }

  onDayChange(day) {
    const {
      onDayChange,
    } = this.props;
    onDayChange(moment(day));
  }

  calculateState(props) {
    const {
      minDate,
      maxDate,
      disabledWeekDays,
      disabledDays,
      day,
    } = props;
    const actualDisabledWeekDays = (disabledWeekDays || []).map(day => day % 7);
    let disabledDaysD = [
      ...disabledDays,
      {
        daysOfWeek: actualDisabledWeekDays,
      },
    ];
    let initialMonth = new Date();
    const extra = { };
    if (minDate) {
      const before = minDate.toDate();
      extra.before = before;
      initialMonth = before;
    }
    if (maxDate) {
      extra.after = maxDate.toDate();
    }
    if (minDate || maxDate) {
      disabledDaysD = [...disabledDaysD, extra];
    }
    this.setState({
      disabledDays: disabledDaysD,
      day: day ? day.toDate() : '',
      initialMonth,
      fromMonth: initialMonth,
    });
  }

  renderDay(day, mods) {
    const { disabled } = mods;
    const { getDayText } = this.props;
    const nameDay = day.getDate();
    const monthNames = ['jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];

    // const nameMonth where it is the name of the month with 3 characters and we get it from day.getMonth() which is the number of the month
    const nameMonthBig = monthNames[day.getMonth()];
    const nameMonthSmall = day.getMonth() + 1;

    const MonthBig = styled.div`
      display: inline-block;
      @media screen and (max-width: 500px) {
        display: none;
      }
    `;
    const MonthSmall = styled.div`
      display: none;
      @media screen and (max-width: 500px) {
        display: inline-block;
      }
    `;

    return (
      <DayContainer disabled={disabled} className={disabled ? undefined : 'selectableDay'}>
        {nameDay}<MonthBig>. {nameMonthBig}</MonthBig><MonthSmall>/{nameMonthSmall}</MonthSmall> {disabled ? undefined : getDayText(moment(day))}
      </DayContainer>
    );
  }

  render() {
    const {
      disabledDays,
      day,
      initialMonth,
      fromMonth,
    } = this.state;
    const {
      dateFormat,
      disabled,
      placeholder,
      customRef,
      error,
    } = this.props;
    return (
      <Wrapper>
        <DayPickerMomentLib>
          {({
            default: MomentLocaleUtils,
            formatDate,
            parseDate,
          }) => (
            <DayPickerInput
              formatDate={(...args) => capitalizeFirstLetter(formatDate(...args))}
              parseDate={parseDate}
              onDayChange={this.onDayChange}
              format={dateFormat}
              component={CustomInput}
              inputProps={{
                disabled,
                readOnly: true,
                error,
                'data-recording-gdpr-safe': true,
              }}
              value={day}
              placeholder={placeholder}
              dayPickerProps={{
                renderDay: this.renderDay,
                disabledDays,
                showOutsideDays: true,
                showWeekNumbers: true,
                locale: 'da',
                localeUtils: MomentLocaleUtils,
                initialMonth,
                navbarElement: StyledNavBarElement,
                fromMonth,
              }}
              ref={customRef}
            />
          )}
        </DayPickerMomentLib>
      </Wrapper>
    );
  }
}
